import(/* webpackMode: "eager" */ "/codebuild/output/src2396152933/src/apps/fanychance/src/app/error.tsx");
